import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

export const getFacilityNow = (facilityTimezone: string): Date => {
  const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const nowUtc = zonedTimeToUtc(new Date(), clientTimezone);
  const nowFacility = utcToZonedTime(nowUtc, facilityTimezone);
  return nowFacility;
};
